export default __webpack_public_path__ + "static/media/0049.0884c13b.png";